export const STORAGE_KEY = 'jwt_access_token';
export const CURRENT_USER = 'kind_and_clear_current_user';
